// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import vueRouter from 'vue-router'
import routes from './router'
import $ from 'jquery'
import VueResource from 'vue-resource'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import '../static/css/base.css'
import '../static/css/resetting.css'

import AMap from 'vue-amap'
Vue.use(AMap);
AMap.initAMapApiLoader({
  key: '097db98a38ffaeae6ebbf65a063a7576',
  plugin: [
    "AMap.Autocomplete", //输入提示插件
    "AMap.PlaceSearch", //POI搜索插件
    "AMap.Scale", //右下角缩略图插件 比例尺
    "AMap.OverView", //地图鹰眼插件
    "AMap.ToolBar", //地图工具条
    "AMap.MapType", //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
    "AMap.PolyEditor", //编辑 折线多，边形
    "AMap.CircleEditor", //圆形编辑器插件
    "AMap.Geolocation" //定位控件，用来获取和展示用户主机所在的经纬度位置
  ]
});
Vue.use(VueResource)
Vue.use(vueRouter)
Vue.config.productionTip = false

var router = new vueRouter({
  routes
})
import store from './store/store.js'
// router.afterEach((routes) => {
//   routes.matched.forEach((path)=>{
//     document.title=routes.meta.title;
//   })
// });

/* eslint-disable no-new */
new Vue({
  el:'#app',
  store,
  router : router,
  render : (function (c) {
    return c(App);
  }),
})



// WEBPACK FOOTER //
// ./src/main.js